import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface PayloadState {
  currentPathname: string | null;
  previousPathname: string | null;
  back?: boolean;
}

export interface HistoryState extends PayloadState {
  pathStack: string[];
  back: boolean;
}

export const initialState: HistoryState = {
  currentPathname: null,
  previousPathname: null,

  // if `true` indicates next location change is a move backwards in the
  // history stack
  back: false,
  pathStack: [],
};

const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    updatePathStack(state, action: PayloadAction<string[]>) {
      state.pathStack = action.payload;
    },
    navigateBack(state) {
      state.back = true;
    },
    urlPathChanged(state, action: PayloadAction<PayloadState>) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { navigateBack, urlPathChanged, updatePathStack } =
  historySlice.actions;
export default historySlice.reducer;
